'use strict';

import { Injectable, Inject } from 'ng-metadata/core';

    @Injectable()
    export class PageNavMenuService{

        private _pageInView: number;
        private _needToUpdatePivInSafari: boolean;
        
        constructor() {
        }
        
        get pageInView() : number{
            return this._pageInView;
        }
        
        set pageInView(updatedPage: number){
            this._pageInView= updatedPage;            
        }
        
        get needToUpdatePivInSafari() : boolean{
            return this._needToUpdatePivInSafari;
        }
        
        set needToUpdatePivInSafari(isNeedToUpdate: boolean){
            this._needToUpdatePivInSafari= isNeedToUpdate;            
        }
  

     }







// WEBPACK FOOTER //
// ./src/main/webapp/components/search/searchResult/searchResultList/pageNavMenu/pageNavMenu.service.ts